import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Location"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.75 9.53271C3.81172 5.03714 7.50438 1.44183 12 1.50021C16.4956 1.44183 20.1883 5.03714 20.25 9.53271C20.2481 11.2784 19.6679 12.9743 18.6 14.3552L12 24.0002L5.4 14.3552C4.33213 12.9743 3.7519 11.2784 3.75 9.53271ZM18.75 9.53273C18.6802 5.86911 15.6639 2.95005 12 3.00023C8.33605 2.95005 5.31981 5.86911 5.25 9.53273C5.24891 10.9744 5.73821 12.3735 6.6375 13.5002L12 21.3452L17.4075 13.4402C18.2779 12.3237 18.7504 10.9484 18.75 9.53273ZM12 7.50021C13.2426 7.50021 14.25 8.50757 14.25 9.75021C14.25 10.9929 13.2426 12.0002 12 12.0002C10.7574 12.0002 9.75 10.9929 9.75 9.75021C9.75 8.50757 10.7574 7.50021 12 7.50021ZM8.25 9.75021C8.25 7.67915 9.92893 6.00021 12 6.00021C14.0711 6.00021 15.75 7.67915 15.75 9.75021C15.75 11.8213 14.0711 13.5002 12 13.5002C9.92893 13.5002 8.25 11.8213 8.25 9.75021Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Location.vue"]]);
